// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LOU5FCmxKT0Q8y6_ThG--","groupsList":"_39lUfTEcoYsLD7-J_JOnoi"};